import React, { memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
// import PropTypes from 'prop-types';

import { Routes } from '@components';
import { getProjectInfoFromLocation } from '@utils/history';
import { generateProjectUrlSearch } from '@utils/common';
import useSubmoduleName from '@hooks/useSubmoduleName';
import { DEFALUT_PERMISSION_SECTION } from '@model';

function InsightRoute({ match, routes, history }) {
  const currentId = useSelector(({ common }) => common.currentId);

  useEffect(() => {
    // const { currentId, projectName } = queryURLParams(
    //   decodeURIComponent(history.location.search),
    // );

    const { projectId } = getProjectInfoFromLocation(history.location);

    if (!projectId) {
      history.replace(
        `${history.location.pathname}?${generateProjectUrlSearch(currentId)}`,
      );
    }
  }, [history.location.pathname]);
  const subModuleKey = history.location.pathname.split('/')[2];
  const currentSubmoduleName = useSubmoduleName(
    DEFALUT_PERMISSION_SECTION.INSIGHT,
    subModuleKey,
  );
  return (
    <div className="insights">
      <Routes
        routeData={routes}
        rootPath={match.path}
        currentSubmoduleName={currentSubmoduleName}
      />
    </div>
  );
}

InsightRoute.propTypes = {};

export default memo(InsightRoute);
